// decision-auto-env-key-sources.ts — V2-1 review M2 (spec §4.1 luật auto điều 3).
//
// Tên key env làm token ranh giới: `env.example`/`.env.example` ở gốc worktree
// + `env_allowlist` của `.avatar/verification-profile.json`. Worker sửa được
// worktree ngay trước khi controller xét auto (recovery chưa chạy), nên KHÔNG
// chỉ đọc bản live: lấy HỢP của bản live và bản đã commit ở HEAD (commit do
// controller tạo). Caller hợp thêm tập key chụp lúc khởi động run
// (`buildDecisionAutoRunConfig`) — xoá key rồi commit qua một ticket cũng
// không làm mất token trong run đó.
import { readFile } from "node:fs/promises";
import { join } from "node:path";
import { VERIFICATION_PROFILE_PATH } from "./controller-owned-paths.js";
import { loadCommittedBlueprintBytes } from "./mission-blueprint-committed-bytes-check.js";

const ENV_EXAMPLE_FILES = ["env.example", ".env.example"];

function envFileKeys(text: string): string[] {
  const keys: string[] = [];
  for (const line of text.split(/\r?\n/)) {
    const match = /^\s*(?:export\s+)?([A-Za-z_][A-Za-z0-9_]*)\s*=/.exec(line);
    if (match?.[1] !== undefined) keys.push(match[1]);
  }
  return keys;
}

function profileAllowlistKeys(text: string): string[] {
  try {
    const raw = JSON.parse(text) as { recipes?: Array<{ env_allowlist?: unknown }> };
    return (raw.recipes ?? []).flatMap((r) =>
      Array.isArray(r.env_allowlist) ? r.env_allowlist.filter((k) => typeof k === "string") : [],
    );
  } catch {
    return [];
  }
}

/** Bản live + bản HEAD của một file (vắng/không đọc được ⇒ bỏ qua bản đó). */
async function liveAndHeadTexts(repoDir: string, path: string): Promise<string[]> {
  const texts: string[] = [];
  try {
    texts.push(await readFile(join(repoDir, path), "utf8"));
  } catch {
    // vắng ở worktree
  }
  const head = await loadCommittedBlueprintBytes(repoDir, path, "HEAD");
  if (head !== undefined) texts.push(head.toString("utf8"));
  return texts;
}

export async function readEnvKeyNamesLiveAndHead(repoDir: string): Promise<string[]> {
  const keys: string[] = [];
  for (const file of ENV_EXAMPLE_FILES) {
    for (const text of await liveAndHeadTexts(repoDir, file)) keys.push(...envFileKeys(text));
  }
  for (const text of await liveAndHeadTexts(repoDir, VERIFICATION_PROFILE_PATH)) {
    keys.push(...profileAllowlistKeys(text));
  }
  return [...new Set(keys)];
}
